/**
 * permission接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const permissionEndpoints: ApiEndpoint[] = [
  {
    id: "admin-permissions",
    method: "GET",
    path: "/api/admin/:adminId/permissions",
    name: "获取管理员权限",
    description: "获取指定管理员的权限列表",
    category: API_CATEGORIES.PERMISSION,
    pathParams: [{ name: "adminId", type: "string", required: true, description: "管理员ID" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data", type: "array", description: "权限列表" },
    ],
    requiredPermission: "msadmin:admins:view",
  },
  {
    id: "admin-assign-permission",
    method: "POST",
    path: "/api/admin/:adminId/permissions",
    name: "为管理员分配权限",
    description: "为指定管理员分配权限",
    category: API_CATEGORIES.PERMISSION,
    pathParams: [{ name: "adminId", type: "string", required: true, description: "管理员ID" }],
    bodyParams: [{ name: "permission_id", type: "string", required: true, description: "权限ID" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
    ],
    requiredPermission: "msadmin:admins:assign-permissions",
  },
  {
    id: "admin-revoke-permission",
    method: "DELETE",
    path: "/api/admin/:adminId/permissions/:permissionId",
    name: "撤销管理员权限",
    description: "撤销指定管理员的权限",
    category: API_CATEGORIES.PERMISSION,
    pathParams: [
      { name: "adminId", type: "string", required: true, description: "管理员ID" },
      { name: "permissionId", type: "string", required: true, description: "权限ID" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
    ],
    requiredPermission: "msadmin:admins:revoke-permissions",
  },
  {
    id: "admin-batch-revoke-permissions",
    method: "POST",
    path: "/api/admin/:adminId/permissions/batch-revoke",
    name: "批量撤销管理员权限",
    description: "批量撤销指定管理员的权限",
    category: API_CATEGORIES.PERMISSION,
    pathParams: [{ name: "adminId", type: "string", required: true, description: "管理员ID" }],
    bodyParams: [{ name: "permission_ids", type: "array", required: true, description: "权限ID数组", example: "[\"1\", \"2\"]" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
    ],
    requiredPermission: "msadmin:admins:revoke-permissions",
  },
  {
    id: "admin-permission-stats",
    method: "GET",
    path: "/api/admin/:adminId/permissions/stats",
    name: "获取管理员权限统计",
    description: "获取指定管理员的权限统计信息",
    category: API_CATEGORIES.PERMISSION,
    pathParams: [{ name: "adminId", type: "string", required: true, description: "管理员ID" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data", type: "object", description: "权限统计信息" },
    ],
    requiredPermission: "msadmin:admins:view",
  },
];
